import { render, staticRenderFns } from "./SubjectsDropdown.vue?vue&type=template&id=3bdc5a03&"
import script from "./SubjectsDropdown.vue?vue&type=script&lang=js&"
export * from "./SubjectsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports